import { PayloadAction } from '@reduxjs/toolkit';
//@ts-ignore
import * as api from '@yandex-int/k-common/client/api';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { showNetworkError } from 'platform-components';
import { reportMessage } from 'platform-components/utils';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import { actions } from './actions';
import { getQuizDraft } from './selectors';
import { QuizByLessonDraft, QuizDraft } from './typings';

export function* quizEditorWatcher() {
    yield takeEvery(actions.createQuiz, createQuizSaga);
    yield takeEvery(actions.updateQuiz, updateQuizSaga);
    yield takeEvery(
        [
            actions.setQuizDraft,
            actions.setQuestionTitle,
            actions.setAnswerStatus,
            actions.setAnswerValue,
            actions.addSlide,
            actions.deleteSlide,
            actions.copySlide,
            actions.setQuizTitle,
        ],
        quizChangeSaga
    );
    yield takeEvery(actions.getQuiz, getQuizSaga);
    yield takeEvery(actions.getQuizByLessonId, getQuizByLessonIdSaga);
}

function* prepareQuiz(quiz: QuizDraft) {
    const quizDraft: QuizDraft = JSON.parse(JSON.stringify(quiz));

    delete quizDraft.isValid;
    for (const question of quizDraft.questions) {
        delete question.isValid;
    }

    return quizDraft;
}

function* createQuizSaga() {
    const quizDraft: QuizDraft = yield prepareQuiz(yield select(getQuizDraft));

    try {
        const response: QuizDraft = yield call(api.postCreateQuiz, quizDraft);
        yield put(actions.setViewType('edit'));
        yield put(actions.setQuizSentStatus(LOADING_STATUSES.SUCCESS));
        yield put(actions.setQuizId(response.id));
    } catch (error) {
        reportMessage(`Произошла ошибка (${error.status}) при сохранении викторины`, error.message);

        yield put(actions.setQuizSentStatus(LOADING_STATUSES.ERROR));
        yield put(showNetworkError());
    }
}

function* updateQuizSaga() {
    const quizDraft: QuizDraft = yield prepareQuiz(yield select(getQuizDraft));

    try {
        yield call(api.putUpdateQuiz, quizDraft.id, quizDraft);
        yield put(actions.setQuizSentStatus(LOADING_STATUSES.SUCCESS));
    } catch (error) {
        reportMessage(`Произошла ошибка (${error.status}) при сохранении викторины`, error.message);

        yield put(actions.setQuizSentStatus(LOADING_STATUSES.ERROR));
        yield put(showNetworkError());
    }
}

function* getQuizSaga(action: PayloadAction<string>) {
    try {
        const response: QuizDraft = yield call(api.getQuiz, action.payload);
        yield put(actions.setQuizDraft(response));
    } catch (error) {
        reportMessage(`Произошла ошибка (${error.status}) при получении викторины`, error.message);
        yield put(showNetworkError());
    }
}

function* getQuizByLessonIdSaga(action: PayloadAction<string>) {
    try {
        const response: QuizByLessonDraft = yield call(api.getQuizByLesson, action.payload);
        const quiz = {
            title: `Викторина занятия ${action.payload}`,
            subject: null,
            questions: response.questions.map((q) => {
                return {
                    title: q.question,
                    answers: q.answers.map((answer, index) => {
                        return {
                            value: answer,
                            correct: index === q.correctAnswerIndex,
                        };
                    }),
                };
            }),
        };

        yield put(actions.setQuizDraft(quiz));
    } catch (error) {
        reportMessage(`Произошла ошибка (${error.status}) при получении викторины`, error.message);
        yield put(showNetworkError());
    }
}

function* quizChangeSaga() {
    yield put(actions.setQuizSentStatus(LOADING_STATUSES.UNSENT));
    yield put(actions.validate());
}
